'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filterMiddleware;

var _constants = require('redux/constants');

function filterPaymentByIsMobileField(action) {
    if (action.result && action.result.services) {
        var services = action.result.services || [];
        services = services.filter(function (item) {
            return item.hasOwnProperty('is_mobile') && item.is_mobile === false || !item.hasOwnProperty('is_mobile');
        });

        action.result.services = services;
    }
}

function filterPaymentByEnable(action) {
    if (action.result && action.result.services) {
        var services = action.result.services || [];
        services = services.filter(function (item) {
            return item.enabled && !item.disabled && item.settings && item.settings.enable;
        });

        action.result.services = services;
    }
}

var filterWords = ['pay.alfa_label', 'pay.mail_label', 'pay.your_number', 'pay.required', 'pay.enter_phone_number', 'pay.enter_phone_number_qiwi', 'services.title', 'pay.bill', 'common.print', 'paymentin.cyberplat.maintext', 'paymentin.bill_number', 'paymentin.your_phone', 'paymentin.sum_to_pay', 'paymentin.back_to_shop', 'paymentin.back_to_profile', 'paymentin.cyberplat.maintext', 'events.account', 'paymentin.cyberplat.purpose', 'services.alfa.check.instruction', 'services.alfa.connect_error', 'services.alfa.invoice_in_alfa', 'services.alfa.login_error', 'services.alfa.unknown_error', 'services.ruru.invoice', 'services.ruru.sum_to_pay'];

function filterMiddleware(ibonus) {
    return function (_ref) {
        var dispatch = _ref.dispatch,
            getState = _ref.getState;

        return function (next) {
            return function (action) {
                if (action.type) {
                    switch (action.type) {
                        case _constants.PaymentConstants.SHOW_SUCCESS:
                            filterPaymentByIsMobileField(action);
                            filterPaymentByEnable(action);
                            break;
                    }
                }
                return next(action);
            };
        };
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/filterMiddleware.js
// module id = 1889
// module chunks = 0